import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const WarningOutline: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      className={className}
      aria-hidden={!title}
      focusable='false'
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d='M21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12ZM22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12Z'
        fill={fill}
      />
      <path
        d='M12.0008 14.25L12.0779 14.2539C12.456 14.2924 12.7508 14.6118 12.7508 15C12.7508 15.3882 12.456 15.7076 12.0779 15.7461L12.0008 15.75H11.992C11.5778 15.75 11.242 15.4142 11.242 15C11.242 14.5858 11.5778 14.25 11.992 14.25H12.0008Z'
        fill={fill}
      />
      <path
        d='M11.25 12V8C11.25 7.58579 11.5858 7.25 12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V12C12.75 12.4142 12.4142 12.75 12 12.75C11.5858 12.75 11.25 12.4142 11.25 12Z'
        fill={fill}
      />
    </svg>
  )
}

export default WarningOutline
